import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const CaptionButton = ({ keyLabel, label, disabled, onClick }) => {
  const baseGradient = 'linear-gradient(180deg, rgba(60,60,60,0.95) 0%, rgba(32,32,32,0.95) 100%)';
  const hoverGradient = 'linear-gradient(180deg, rgba(72,72,72,0.95) 0%, rgba(40,40,40,0.95) 100%)';
  const disabledBg = '#121212';
  const dividerColor = disabled ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.5)';

  return (
    <Box
      component="button"
      type="button"
      disabled={disabled}
      onClick={onClick}
      sx={{
        flex: 1,
        height: 51,
        borderRadius: 1,
        display: 'flex',
        alignItems: 'stretch',
        overflow: 'hidden',
        border: disabled ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.45)',
        background: disabled ? disabledBg : baseGradient,
        color: disabled ? 'rgba(255,255,255,0.28)' : '#F5F6F9',
        cursor: disabled ? 'default' : 'pointer',
        transition: 'background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease',
        boxShadow: disabled ? 'none' : '0 12px 28px rgba(0,0,0,0.35)',
        '&:hover': disabled
          ? undefined
          : {
              background: hoverGradient,
              transform: 'translateY(-1px)',
              boxShadow: '0 16px 36px rgba(0,0,0,0.45)',
            },
        '&:active': disabled
          ? undefined
          : {
              transform: 'translateY(0)',
              boxShadow: '0 10px 24px rgba(0,0,0,0.38)',
            },
      }}
    >
      {keyLabel ? (
        <Box
          sx={{
            px: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRight: `1px solid ${dividerColor}`,
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 700,
              letterSpacing: '0.04em',
              whiteSpace: 'nowrap',
              color: disabled ? 'rgba(255,255,255,0.28)' : '#FFFFFF',
              fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
            }}
          >
            {keyLabel}
          </Typography>
        </Box>
      ) : null}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: '0.04em',
            color: disabled ? 'rgba(255,255,255,0.28)' : '#FFFFFF',
            textTransform: 'uppercase',
            fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
            textAlign: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

CaptionButton.propTypes = {
  keyLabel: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CaptionButton;

